 document.addEventListener("DOMContentLoaded", function() {
    const modal = document.getElementById("itemModal");
    const modalImg = document.getElementById("modalImage");
    const modalTitle = document.getElementById("modalTitle");
    const modalLink = document.getElementById("modalLink");
    const modalDesc = document.getElementById("modalDesc");

    const copyBtn = document.getElementById("copyLink");
    const shareFb = document.getElementById("shareFacebook");
    const shareTw = document.getElementById("shareTwitter");
    const shareWa = document.getElementById("shareWhatsapp");
    const shareLn = document.getElementById("shareLinkedin");
    const shareSn = document.getElementById("shareSnapchat");
    const shareMs = document.getElementById("shareMessenger");

    // Open modal
    document.querySelectorAll(".ellipsis-btn").forEach(btn => {
      btn.addEventListener("click", function(e) {
        e.stopPropagation();
        const parent = this.closest(".linktree-item");
        const title = parent.getAttribute("data-title");
        const link = parent.getAttribute("data-link");
        const image = parent.getAttribute("data-image");
        const desc = parent.getAttribute("data-desc");

        modalImg.src = image;
        modalTitle.textContent = title;
        modalLink.href = link;
        modalLink.textContent = link;
        modalDesc.textContent = desc;
        // Social share links
        shareFb.href = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(link)}`;
        shareTw.href = `https://twitter.com/intent/tweet?url=${encodeURIComponent(link)}&text=${encodeURIComponent(title)}`;
        shareWa.href = `https://api.whatsapp.com/send?text=${encodeURIComponent(title + " " + link)}`;
        shareLn.href = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(link)}`;
        shareSn.href = `https://www.snapchat.com/scan?attachmentUrl=${encodeURIComponent(link)}`;
        shareMs.href = `fb-messenger://share?link=${encodeURIComponent(link)}`;

        modal.style.display = "block";
        setTimeout(() => modal.classList.add("show"), 10); 
      });
    });

    // Close modal only with X (with fade out)
    document.querySelector(".close-btn").onclick = () => {
      modal.classList.remove("show");
      setTimeout(() => { modal.style.display = "none"; }, 300);
    };


    // Copy link
    copyBtn.addEventListener("click", function() {
      const link = modalLink.href;
      navigator.clipboard.writeText(link).then(() => {
        alert("Link copied!");
      });
    });
  });